"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = exports.BaseImage = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _CleanTag = require("../CleanTag");
var _LazyImage = require("./LazyImage");
var _excluded = ["lazyLoad", "preventRightClick"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// @ts-expect-error  MIGRATE_STRICT_MODE
var BaseImage = (0, _styledComponents.default)(_CleanTag.CleanTag.as("img")).withConfig({
  displayName: "Image__BaseImage",
  componentId: "sc-sq2zgu-0"
})(["", ""], (0, _styledSystem.compose)(_styledSystem.space, _styledSystem.width, _styledSystem.height, _styledSystem.maxHeight, _styledSystem.borderRadius));

/** A web-only Image component. */
exports.BaseImage = BaseImage;
var Image = function Image(_ref) {
  var _ref$lazyLoad = _ref.lazyLoad,
    lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
    _ref$preventRightClic = _ref.preventRightClick,
    preventRightClick = _ref$preventRightClic === void 0 ? false : _ref$preventRightClic,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_LazyImage.LazyImage, _extends({
    preload: !lazyLoad,
    imageComponent: BaseImage,
    onContextMenu: function onContextMenu(e) {
      return preventRightClick && e.preventDefault();
    }
  }, rest));
};
exports.Image = Image;
Image.displayName = "Image";
//# sourceMappingURL=Image.js.map